// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-amendment-confirmation-popup h3 {
  font-size: 36px;
}
.bulk-amendment-confirmation-popup span {
  font-size: 28px;
}
.bulk-amendment-confirmation-popup .buttons {
  margin-top: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ConfirmationPopup/BulkAmendmentConfirmationPopup/index.scss"],"names":[],"mappings":"AAEE;EACE,eAAA;AADJ;AAGE;EACE,eAAA;AADJ;AAGE;EACE,gBAAA;AADJ","sourcesContent":["\n.bulk-amendment-confirmation-popup {\n  h3 {\n    font-size: 36px;\n  }\n  span {\n    font-size: 28px;\n  }\n  .buttons {\n    margin-top:3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
